import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1976537694/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/_components/home-component.tsx");
